/*eslint no-unused-vars: ["error", { "args": "none" }]*/
import { GestioneClubApi } from "@/generated-sources/gestioneclub-api";
import { Configuration } from "@/generated-sources/prenotazioni-api";
import { UserFilters } from "@/models/filters.models";
import { store } from "@/store/store";
import axios from "axios";

// Lettura SINCRONA dei token dallo store per evitare race conditions
const getAccessTokenSync = (): string => {
  const tokens = store.getters.getTokens as {
    accessToken: string;
  };
  return tokens?.accessToken || '';
};

// Funzione asincrona mantenuta per compatibilità (wrapper)
const getAccessToken = async (): Promise<string> => {
  return getAccessTokenSync();
};

const configuration = new Configuration({
  basePath: process.env.VUE_APP_API_ENDPOINT,
  accessToken: () => {
    // Lettura sincrona dallo store invece di dispatch asincrono
    const tokens = store.getters.getTokens as any;
    return tokens.accessToken;
  },
});
const gestioneClubApi = new GestioneClubApi(configuration);

export async function getUserClubByUserId(clubId: string, userId: string) {
  try {
    return await gestioneClubApi.getUserClubByUserId(clubId, userId);
  } catch (error) {
    throw error;
  }
}
export async function getClubPictures(clubId: string) {
  try {
    return await gestioneClubApi.getClubPictures(clubId);
  } catch (error) {
    throw error;
  }
}
export async function getClubLogo(clubId: string) {
  try {
    return await gestioneClubApi.getClubLogo(clubId);
  } catch (error) {
    throw error;
  }
}
export async function findUsersClubsForClub(
  clubId: string,
  filters: UserFilters
) {
  try {
    return await gestioneClubApi.findUsersClubsForClub(
      clubId,
      filters.limit,
      filters.page,
      filters.min_cancellations,
      filters.min_bookings,
      filters.banned,
      filters.name
    );
  } catch (error) {
    throw error;
  }
}
export async function findPaymentsForClub(clubId: string, date: string) {
  try {
    return await gestioneClubApi.findPaymentsForClub(clubId, date);
  } catch (error) {
    throw error;
  }
}

export async function getPaymentsWithFilters(
  clubId: string,
  filters: {
    paymentDateFrom?: string | null;
    paymentDateTo?: string | null;
    bookingDateFrom?: string | null;
    bookingDateTo?: string | null;
    bookingStatus?: string | null;
    page?: number;
    limit?: number;
    paymentStatus?: string | null;
    userId?: string | null;
    sortBy?: string | null;
    sortDirection?: string | null;
  }
) {
  try {
    const accessToken = await getAccessToken();

    console.log('[getPaymentsWithFilters] Filters ricevuti:', filters);
    console.log('[getPaymentsWithFilters] filters.userId:', filters.userId);

    // Costruisco i parametri della query string
    const params: any = {};

    // Aggiungo i filtri solo se hanno un valore
    if (filters.paymentStatus) params.paymentStatus = filters.paymentStatus;
    if (filters.userId) {
      params.userId = filters.userId;
      console.log('[getPaymentsWithFilters] Aggiunto parametro userId:', params.userId);
    }
    if (filters.paymentDateFrom) params.paymentDateFrom = filters.paymentDateFrom;
    if (filters.paymentDateTo) params.paymentDateTo = filters.paymentDateTo;
    if (filters.bookingDateFrom) params.bookingDateFrom = filters.bookingDateFrom;
    if (filters.bookingDateTo) params.bookingDateTo = filters.bookingDateTo;
    if (filters.bookingStatus && filters.bookingStatus !== 'TUTTE') params.bookingStatus = filters.bookingStatus;

    // Aggiungo i parametri di paginazione
    if (filters.page) params.page = filters.page;
    if (filters.limit) params.limit = filters.limit;

    // Aggiungo i parametri di sorting
    if (filters.sortBy) params.sortBy = filters.sortBy;
    if (filters.sortDirection) params.sortDirection = filters.sortDirection;

    console.log('[getPaymentsWithFilters] Chiamata API con params:', params);

    // Chiamo l'endpoint corretto /v2/gestioneclub/{clubId}/payments
    const response = await axios.get(
      `${process.env.VUE_APP_API_ENDPOINT}/v2/gestioneclub/${clubId}/payments`,
      {
        params,
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    console.log('[getPaymentsWithFilters] Risposta API:', response.data);
    return response.data;
  } catch (error) {
    throw error;
  }
}
export async function updateClubPicture(
  clubId: string,
  base64: string,
  isMain: boolean
) {
  try {
    return await gestioneClubApi.updateClubPicture(clubId, {
      base64,
      isMain,
    });
  } catch (error) {
    throw error;
  }
}
export async function updateClubLogo(clubId: string, base64: string) {
  try {
    return await gestioneClubApi.updateClubLogo(clubId, {
      picture: base64,
    });
  } catch (error) {
    throw error;
  }
}
export async function deleteClubPicture(clubId: string, pictureId: string) {
  try {
    return await gestioneClubApi.deleteClubPicture(clubId, pictureId);
  } catch (error) {
    throw error;
  }
}
export async function setMainClubPicture(clubId: string, pictureId: string) {
  try {
    return await gestioneClubApi.setMainClubPicture(clubId, pictureId);
  } catch (error) {
    throw error;
  }
}
